import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './Navigation.css'
import { createB2BAPI } from "../../../api/Interceptor";
const Navigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeRoute, setActiveRoute] = useState(location.pathname);
    const [loading, setLoading] = useState(false);
    const [profile, setProfile] = useState(null);
    const [recomend, setRecomend] = useState([]);
    const [customer, setCustomer] = useState([]);

    const userId = JSON.parse(localStorage.getItem('user'))?.userId
    const isCustomer = typeof userId === "string" && userId.startsWith("CUST-");
    const isVendor = typeof userId === "string" && userId.startsWith("VEN-") || /^B\d+$/.test(userId);
    const B2B_API = createB2BAPI();

    useEffect(() => {
        setActiveRoute(location.pathname);
    }, [location.pathname]);

    useEffect(() => {
        fetchAll();
    }, [location.pathname])

    useEffect(() => {
        fetchCustomerData();
    }, [])

    const handleNavigation = (path) => {
        navigate(path);
    };


    const fetchAll = async () => {
        if (!isVendor) {
            try {
                setLoading(true);
                const res2 = await B2B_API.get("customer/profile").json();
                setProfile(res2.response)
                setLoading(false);
            } catch (error) {
                console.error("Error fetching recommended items:", error);
            }
        }
    };

    const fetchCustomerData = async () => {
        if (!userId) return;
        try {
            const res = await B2B_API.get(`vendor/${userId}`).json();
            const customerRes = res.response;
            setCustomer(prev => ({
                ...prev,
                ...customerRes,
                regionId: customerRes?.regionId || ''
            }));
        } catch (error) {
            console.error('Error fetching customer data:', error);
        }
    };


    return (
        <div className="absoluter">
            <div className="navigation">
                <div className="route-items">
                    {!isVendor && <div className={`route-item ${activeRoute === "/fabricInquiries" ? 'active' : ''}`} onClick={() => handleNavigation('/fabricInquiries')}>Custom Fabric Inquries</div>}
                    {/* {isVendor && <div className={`route-item ${activeRoute === "/vendorFabricInquiries" ? 'active' : ''}`} onClick={() => handleNavigation('/vendorFabricInquiries')}>New Development</div>} */}
                    {isVendor && <div className={`route-item ${activeRoute === "/VendorHome" ? 'active' : ''}`} onClick={() => handleNavigation('/VendorHome')}>My Products</div>}
                    {!isVendor && <div className={`route-item ${activeRoute === "/wishList" ? 'active' : ''}`} onClick={() => handleNavigation('/wishList')}>Wishlist</div>}
                    {!isVendor && <div className={`route-item ${activeRoute === "/mtoInguiry" ? 'active' : ''}`} onClick={() => handleNavigation('/mtoInguiry')}>MTO Enquiries</div>}
                    <div className="hr"></div>
                    {isVendor && <div className={`route-item ${activeRoute === "/vendorStockAvailable" ? 'active' : ''}`} onClick={() => handleNavigation('/vendorStockAvailable')}> Vendor Stock Available</div>}
                    {isVendor && <div className={`route-item ${activeRoute === "/madeToOrder" ? 'active' : ''}`} onClick={() => handleNavigation('/madeToOrder')}>Enquiries</div>}
                    {isVendor ? <div className={`route-item ${activeRoute === "/Po-Wholesale" ? 'active' : ''}`} onClick={() => handleNavigation('/Po-Wholesale')}>Wholesale</div> :

                        <div className={`route-item ${activeRoute === "/place-Orders" ? 'active' : ''}`} onClick={() => handleNavigation('/place-Orders')}>Fabric Orders</div>}
                    {isVendor ?

                        <div className={`route-item ${activeRoute === "/Po-Sample" ? 'active' : ''}`} onClick={() => handleNavigation('/Po-Sample')}>Sample</div> :
                        <div className={`route-item ${activeRoute === "/place-Sample" ? 'active' : ''}`} onClick={() => handleNavigation('/place-Sample')}>Sample Orders</div>}
                    {isVendor ? <div className={`route-item ${activeRoute === "/Po-Swatch" ? 'active' : ''}`} onClick={() => handleNavigation('/Po-Swatch')}>Swatch</div> :
                        <div className={`route-item ${activeRoute === "/place-Swatch" ? 'active' : ''}`} onClick={() => handleNavigation('/place-Swatch')}>Swatch Orders</div>}
                    <div className="hr"></div>
                    <div className={`route-item ${activeRoute === "/addresses" ? 'active' : ''}`} onClick={() => handleNavigation('/addresses')}>Addresses</div>
                    <div className={`route-item ${activeRoute === "/profile" ? 'active' : ''}`} onClick={() => handleNavigation('/profile')}>Account</div>
                </div>
            </div>
        </div>
    );
};

export default Navigation;
